import React, { useMemo } from "react";
import VStack from "../../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing/react";
import CreateMissionHotellerieRestaurantFees from "../../../screens/create-mission/CreateMissionHotellerieRestaurantFees";
import type { Meta, StoryObj } from "@storybook/react";
import CreateMissionManager from "../../../contexts/CreateMissionManager";
import { useAtomValue } from "jotai";
import { newMissionState } from "../../../atoms/core";
import { EarningType, Repetition, Unit } from "../../../__generated__/graphql";
import { buildContract, buildMission } from "../../factories";
import { AtomsHydrator } from "../../../atoms/atoms-hydrator";

type RepetitionMode = "With" | "Without";

function InnerStory() {
    const mission = useAtomValue(newMissionState);
    return (
        <VStack gap={1} style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}>
            <CreateMissionManager
                onValidate={() => {
                    // eslint-disable-next-line no-console
                    console.log("onValidate", JSON.stringify(mission));
                }}
            >
                <CreateMissionHotellerieRestaurantFees />
            </CreateMissionManager>
        </VStack>
    );
}
function StoryComponent({ repetitionMode }: { repetitionMode: RepetitionMode }) {
    const mission = useMemo(
        () =>
            buildMission({
                currentContract: buildContract({
                    earningType:
                        repetitionMode == "With" ? EarningType.Hourly : EarningType.Package,
                    workingTimeClassicSpec:
                        repetitionMode === "Without"
                            ? {
                                  repetition: Repetition.None,
                                  unit: Unit.Hours,
                                  unitCount: 20,
                                  dailyHours: null,
                              }
                            : {
                                  repetition: Repetition.Week,
                                  unit: Unit.Hours,
                                  unitCount: 42,
                                  dailyHours: null,
                              },
                }),
            }),
        [repetitionMode],
    );
    return (
        <AtomsHydrator atomValues={[[newMissionState, mission]]}>
            <MockedProvider mocks={[]}>
                <InnerStory />
            </MockedProvider>
        </AtomsHydrator>
    );
}

const meta = {
    title: "CreateMission/Hotels Fees",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const WithRepetition: Story = {
    args: {
        repetitionMode: "With",
    },
};
export const NoRepetition: Story = {
    args: {
        repetitionMode: "Without",
    },
};
